import { AppResponse } from '@/shared/application/response/app-response';
import { AppResponseData } from '@/shared/types/app/response/app-response-data';
import { AxiosError, HttpStatusCode } from 'axios';
import { toast } from 'sonner';

export class ServerApiErrorManager {
  /**
   * @todo corrigir repeticao de codigo, mais pra frente.
   * @todo melhorar o nome aq tmb. ver se faz sentido.
   */
  public static handleError(error: unknown): AppResponseData {
    if (
      error instanceof AxiosError &&
      AppResponse.isValid(error.response?.data)
    ) {
      throw (
        (error.response?.data as AppResponseData) || {
          code: HttpStatusCode.InternalServerError,
          tags: ['internal_error'],
          messages: [
            {
              title: 'Falha ao se comunicar com o servidor.',
              description:
                'Tente novamente mais tarde ou entre em contato com o suporte.',
            },
          ],
          payload: {},
        }
      );
    }

    return {
      code: HttpStatusCode.InternalServerError,
      tags: ['internal_error'],
      messages: [
        {
          title: 'Falha ao se comunicar com o servidor.',
          description:
            'Tente novamente mais tarde ou entre em contato com o suporte.',
        },
      ],
      payload: {},
    };
  }

  /**
   * @todo Ver pra adicionar debug qnd esse metodo é chamdo em client side.
   */
  public static handleErrorThrows(error: unknown) {
    if (
      error instanceof AxiosError &&
      AppResponse.isValid(error.response?.data)
    ) {
      throw (
        error.response?.data || {
          code: HttpStatusCode.InternalServerError,
          tags: ['internal_error'],
          messages: [
            {
              title: 'Falha ao se comunicar com o servidor.',
              description:
                'Tente novamente mais tarde ou entre em contato com o suporte.',
            },
          ],
          payload: {},
        }
      );
    }

    throw {
      code: HttpStatusCode.InternalServerError,
      tags: ['internal_error'],
      messages: [
        {
          title: 'Falha ao se comunicar com o servidor.',
          description:
            'Tente novamente mais tarde ou entre em contato com o suporte.',
        },
      ],
      payload: {},
    };
  }

  public static handleMessage(error: unknown) {
    if (
      error instanceof AxiosError &&
      AppResponse.isValid(error.response?.data)
    ) {
      const appResponse = error.response!.data;

      // Faz um reverse() nas mensagens, pra exibir elas na ordem correta, pois o toast() do 'sonner' exibe invertido.
      // Exibe a mensagem em si como aviso, pois é uma resposta esperada.
      for (const message of appResponse.messages.reverse()) {
        toast.warning(message.title, {
          description: message.description,
        });
      }

      return;
    }

    toast.error('Falha ao se comunicar com o servidor.', {
      description:
        'Tente novamente mais tarde ou entre em contato com o suporte.',
    });
  }

  public static getTags(error: unknown) {
    // tags: ['internal_error'],
    // messages: [
    //   {
    //     title: 'Falha ao se comunicar com o servidor.',
    //     description:
    //       'Tente novamente mais tarde ou entre em contato com o suporte.',
    //   },
    // ],

    if (
      error instanceof AxiosError &&
      AppResponse.isValid(error.response?.data)
    ) {
      const appResponse = error.response!.data as AppResponseData; // Tem certeza q vai existir pq foi validado pela AppResonse.isValid().

      return appResponse.tags;
    }

    if (AppResponse.isValid(error)) {
      const appResponse = error as AppResponseData; // Tem certeza q vai existir pq foi validado pela AppResonse.isValid().

      return appResponse.tags;
    }

    // Cuidado ao adicionar tag padrao aqui como ['internal_error'], conferir todos os lugares onde esse metodo eh usado e tmb ver se n vai dar conflito realizar alguma alteracao.
    return [];
  }

  public static getCode(error: unknown) {
    if (
      error instanceof AxiosError &&
      AppResponse.isValid(error.response?.data)
    ) {
      const appResponse = error.response!.data as AppResponseData; // Tem certeza q vai existir pq foi validado pela AppResonse.isValid().

      return appResponse.code;
    }

    if (AppResponse.isValid(error)) {
      const appResponse = error as AppResponseData; // Tem certeza q vai existir pq foi validado pela AppResonse.isValid().

      return appResponse.code;
    }

    // Cuidado ao adicionar tag padrao aqui como ['internal_error'], conferir todos os lugares onde esse metodo eh usado e tmb ver se n vai dar conflito realizar alguma alteracao.
    return HttpStatusCode.InternalServerError;
  }
}
